export default "__VITE_ASSET__D8SiM4uf__"